export default "__VITE_ASSET__Ba8QxLSV__"